export const fileToBase64Old = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result.split(",")[1]); // get Base64 without prefix
    reader.onerror = (error) => reject(error);
  });
};
export const fileToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
};

export const base64ToFile = (base64String, fileName = "downloaded_file", mimeType = "application/octet-stream") => {
  if (!base64String) return null;

  const binary = atob(base64String);
  const len = binary.length;
  const bytes = new Uint8Array(len);
  for (let i = 0; i < len; i++) bytes[i] = binary.charCodeAt(i);

  return new File([bytes], fileName, { type: mimeType });
};

export const base64ToImageJpg = (base64) => {
  const binaryData = atob(base64);

  // Convert the binary data to a Uint8Array
  const arrayBuffer = new ArrayBuffer(binaryData.length);
  const uint8Array = new Uint8Array(arrayBuffer);
  for (let i = 0; i < binaryData.length; i++) {
    uint8Array[i] = binaryData.charCodeAt(i);
  }

  const blob = new Blob([uint8Array], { type: 'image/jpeg' }); // Adjust the MIME type as per your data

  const file = new File([blob], 'filename.jpg', { type: 'image/jpeg' }); // Provide a filename and MIME type

  return file;
}

export const compressImage = (file, maxSizeKB = 100) => {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onload = (event) => {
      const img = new Image();
      img.src = event.target.result;

      img.onload = () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        // scale down to smaller size (e.g. half)
        const scale = Math.sqrt(maxSizeKB * 1024 / file.size);
        const width = img.width * scale;
        const height = img.height * scale;

        canvas.width = width;
        canvas.height = height;
        ctx.drawImage(img, 0, 0, width, height);

        let quality = 0.9;
        let dataUrl = canvas.toDataURL("image/jpeg", quality);

        // Loop: reduce quality until under target size
        while (dataUrl.length / 1024 > maxSizeKB && quality > 0.1) {
          quality -= 0.05;
          dataUrl = canvas.toDataURL("image/jpeg", quality);
        }

        // Convert back to File
        fetch(dataUrl)
          .then((res) => res.blob())
          .then((blob) => {
            const newFile = new File([blob], file.name, { type: "image/jpeg" });
            resolve(newFile);
          });
      };
    };
  });
};

export const downloadAndConvertFile = async (file, fileName) => {
  const convertedFile = file ? base64ToFile(file, fileName) : null;
  downloadFile(convertedFile);
}
export const downloadFile = async (input) => {

  try {
    let fileData = null;
    let fileName = "download";
    let mimeType = "application/octet-stream";

    // 🧠 Detect what was passed in
    if (!input) {
      console.warn("No file data found.");
      return;
    }

    if (input.file || input.fileName) {
      // Case 1: full data object like { file, fileName, mimeType }
      fileData = input.file;
      fileName = input.fileName || fileData?.name || fileName;
      mimeType = input.mimeType || fileData?.type || mimeType;
    } else {
      // Case 2: passed only the file or base64 directly
      fileData = input;
      if (fileData instanceof File) {
        fileName = fileData.name || fileName;
        mimeType = fileData.type || mimeType;
      }
    }

    let blob;

    // 🧩 Handle File or base64 string
    if (fileData instanceof File) {
      blob = fileData;
    } else if (typeof fileData === "string") {
      const base64 = fileData.includes(",")
        ? fileData.split(",")[1] // remove prefix like "data:...;base64,"
        : fileData;

      const binaryData = atob(base64);
      const arrayBuffer = new ArrayBuffer(binaryData.length);
      const uint8Array = new Uint8Array(arrayBuffer);

      for (let i = 0; i < binaryData.length; i++) {
        uint8Array[i] = binaryData.charCodeAt(i);
      }

      blob = new Blob([uint8Array], { type: mimeType });
    } else {
      console.error("Unsupported file type passed:", typeof fileData);
      return;
    }

    // 🔽 Trigger download
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = fileName;
    link.click();
    URL.revokeObjectURL(url);

  } catch (error) {
    console.error("Error downloading file:", error);
  }
};